import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UZURV_API_CONFIGURATION, UzurvApiConfiguration } from '@uzurv/rideWss/configurations/uzurv-api.configuration';
import { SystemMaintenanceException, VersionDeprecatedException } from '@uzurv/rideWss/clara/exceptions';
import { ServiceException } from '@uzurv/rideWss/app/exceptions';

@Injectable()
export class UzurvDataProcessorHttpInterceptor implements HttpInterceptor {
  constructor(@Inject(UZURV_API_CONFIGURATION) protected uzurvApiConfiguration: UzurvApiConfiguration) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only process uzurv api requests
    if (!request.url.startsWith(this.uzurvApiConfiguration.claraApiUrl)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body['errors'] && event.body['errors'].length > 0) {
            // Handle System Events
            event.body['errors'].forEach((errorMessage: string) => {
              if (errorMessage.includes('Maintenance:')) {
                throw new SystemMaintenanceException(errorMessage.replace('Maintenance:', '').trim());
              }

              if (errorMessage.includes('Deprecation:')) {
                throw new VersionDeprecatedException(errorMessage.replace('Deprecation:', '').trim());
              }
            });
            throw new ServiceException(this.extractErrorMessages(event.body['errors']));
          } else if (event.body) {
            event = event.clone({ body: event.body['data'] });
          }
        }
        return event;
      })
    );
  }

  private extractErrorMessages(errors: Array<string>): string {
    return errors.join('<br />');
  }
}
